import { createGlobalStyle } from 'styled-components';
import { generateImageLink } from '../../utils/design.utils';

const FontsStyle = createGlobalStyle`
  ${props => {
    const fonts = props.fonts;
    fonts['Vazir--ttf'] = 'Vazir--ttf';
    fonts['Arial--ttf'] = 'Arial--ttf';
    return Object.keys(fonts).map(font => {
      const [name, extension] = font.split('--');
      const fontUrl = generateImageLink(
        `${process.env.REACT_APP_FILE_SERVER}/resources/fonts/${name.replaceAll(
          '__',
          ' ',
        )}/regular.${extension || 'ttf'}`,
        props.authToken,
      );
      return `
    @font-face {
      font-family: '${font}';
      src: url('${fontUrl}');
    }
  `;
    });
  }}`;

const TextSpacingStyle = createGlobalStyle`
  ${props => {
    const { styleClasses } = props;
    return styleClasses;
  }}`;

const ListBlockStyle = createGlobalStyle`
  ${props => {
    const { styleClasses } = props;
    return styleClasses;
  }}`;

export { FontsStyle, TextSpacingStyle, ListBlockStyle };
